import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { LoadingPage } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { EmployerMyPagesErrorPage } from '../../components';
import {
  getCurrentEmployments,
  getCurrentEmploymentsNew,
  getEmploymentReportStatus,
} from '../../redux/employment/employmentThunks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getCountries } from '../../redux/fora-global/foraGlobalThunks';

export const EmploymentsDataFetcher = () => {
  const dispatch = useAppDispatch();
  const ffManageEmployeeAndEmployment = useAppSelector(
    state => state.foraGlobal.settings.ffManageEmployeeAndEmployment
  );
  const loadingCurrentEmployments = useAppSelector(state => state.employment.loadingCurrentEmployments);
  const loadingCountries = useAppSelector(state => state.foraGlobal.loadingCountries);
  const thunkError = useAppSelector(state => state.error.thunkError);

  useEffect(() => {
    if (ffManageEmployeeAndEmployment) {
      dispatch(getCurrentEmploymentsNew());
    } else if (!ffManageEmployeeAndEmployment) {
      dispatch(getCurrentEmployments());
    }
    dispatch(getCountries());
    dispatch(getEmploymentReportStatus());
  }, [dispatch, ffManageEmployeeAndEmployment]);

  if (
    loadingCurrentEmployments === ThunkRequestStatus.Fulfilled &&
    loadingCountries !== ThunkRequestStatus.Pending // If countries fetch fails we don't want that to break the application, hence we don't check if loadingCountries = Fulfilled
  ) {
    return <Outlet />;
  }
  if (loadingCurrentEmployments === ThunkRequestStatus.Rejected) {
    return <EmployerMyPagesErrorPage type={thunkError?.code} technicalError={thunkError?.message} />;
  } else {
    return <LoadingPage />;
  }
};
